// src/api/ordersTimeWidget.api.ts

import { API } from '.'

export type OrderBucketDTO = {
  serviceType: 'TOJ' | 'CONSULTING' | 'TRAINING' | 'PILOT'
  plannedHours: number
}

export type OrderDTO = {
  id: number
  userId: string
  bankId: number
  customerId?: number
  status: string // "APPROVED" etc.
  startTime: string // ISO
  endTime: string // ISO
  buckets: OrderBucketDTO[]

  // optional extras (not required for logic)
  username?: string
  bankName?: string
}

export type OrdersResponseDTO = {
  items: Record<string, Record<string, OrderDTO[]>> // year -> userId -> orders[]
  page: number
  pageSize: number
  totalItems: number
}

/**
 * IMPORTANT: Adjust the endpoint to your real one if needed.
 * In your codebase you likely already have getOrders({year}).
 * If yes, you can replace usages below and delete this file.
 */

const ordersByYearCache = new Map<number, Promise<OrderDTO[]>>()

export function getOrdersByYearCached(year: number) {
  if (!ordersByYearCache.has(year)) {
    ordersByYearCache.set(year, getOrdersByYear(year))
  }
  return ordersByYearCache.get(year)!
}

export function invalidateOrdersByYear(year: number) {
  ordersByYearCache.delete(year)
}

export async function getOrdersByYear(year: number) {
  const params = new URLSearchParams({ year: String(year) })

  const res = await API<OrdersResponseDTO>(
    `/orders?${params.toString()}`,
    {},
    'Fehler beim Laden der Bestellungen',
    'ORDERS_FETCH_ERROR'
  )

  const yearKey = String(year)
  const byUser = res.items?.[yearKey] ?? {}

  const flat: OrderDTO[] = []
  for (const userId of Object.keys(byUser)) {
    flat.push(...(byUser[userId] ?? []))
  }

  return flat
}
